import { FleContinueWrapper, FleLayout } from "components/views/fle/FleLayout"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { IlloExperts } from "components/views/atoms/Illustrations"
import { LeftArrowAndSpace, ContinueArrow, SpacerSwitcher, SwitchH1ToH2 } from "components/views/fle/Molecules"
import { Body } from "components/views/atoms/Bodies"
import React from "react"
import L10n from "lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export const Answers = ({ onBack, onComplete, benefitConfiguration }) => (
  <FleLayout
    bottomContent={
      <FleContinueWrapper>
        <ContinueArrow onClick={onComplete} />
      </FleContinueWrapper>
    }
  >
    <LeftArrowAndSpace onBack={onBack} />
    <div className="no-pointer-events">
      <FlexRowCenter>
        <IlloExperts />
      </FlexRowCenter>
    </div>
    <SpacerSwitcher />
    <SwitchH1ToH2>{l`Expert help is just a tap away`}</SwitchH1ToH2>
    <Spacer height={0.5} />
    <Body color="black-80">{l`Need help with your benefit? Have a medical question? Don’t know where to start?`}</Body>
    <Spacer height={0.5} />
    <Body color="black-80">
      {l`Schedule a chat with a Carrot Expert`}
      {l`, or browse our library of articles and videos`}.
    </Body>
  </FleLayout>
)
